import React from 'react';
import { connect } from 'react-redux';
import { Card } from 'antd';
import WorkOrderTable from '../WorkOrderTable';
import { isBuyerOrInternalTech } from '../../utils/AuthUtils';
import { EmptyState } from '../empty_state/EmptyState';
import WorkOrderTableRowWithoutActions from '../work_order_table_row_without_actions/WorkOrderTableRowWithoutActions';
import { ShowAllFooterWorkOrders } from '../WorkOrderTable/TableFooter';
import { WORK_ORDER_DISPLAY_STATUSES } from '../../constants/WorkOrderDisplayStatuses';
import { getWorkOrderArchivalKey } from '../../utils/WorkOrderUtils';

const LOCATION_ASSOCIATED_ACTIVE_WORK_ORDERS_TARGET_COLLECTION =
	'FETCH_DATA_FROM_SERVER_locationAssociatedInActiveSupplierWorkOrders';

function LocationActiveWorkOrders({ locationId, currentUser, showActions = true }) {
	return (
		<Card title="Active Work Orders">
			<WorkOrderTable
				CustomHeader={() => <></>}
				CustomWorkOrderRowDisplay={showActions ? undefined : WorkOrderTableRowWithoutActions}
				preAppliedFilters={{
					locationIds: [locationId],
					displayStatuses: [
						WORK_ORDER_DISPLAY_STATUSES.pending,
						WORK_ORDER_DISPLAY_STATUSES.deferred,
						WORK_ORDER_DISPLAY_STATUSES.open,
						WORK_ORDER_DISPLAY_STATUSES.inProgress,
						WORK_ORDER_DISPLAY_STATUSES.hold,
					],
					[getWorkOrderArchivalKey(currentUser)]: false,
				}}
				tableStyle={{
					display: 'flex',
					flexDirection: 'column',
					cursor: 'pointer',
					userSelect: 'none',

					marginTop: '-10px',
					marginBottom: '-9px',
				}}
				initialPagination={{ current: 1, pageSize: 3 }}
				targetCollectionName={LOCATION_ASSOCIATED_ACTIVE_WORK_ORDERS_TARGET_COLLECTION}
				renderEmptyState={() => (
					<EmptyState
						graphic={
							<img
								alt="There aren't any active work orders for this location."
								style={{ marginBottom: 8 }}
								src="https://s3.amazonaws.com/mock-data-assets/categories/images/cactus.svg"
							/>
						}
						headline={'No news is good news.'}
						body={
							<div style={{ textAlign: 'center' }}>
								<div style={{ maxWidth: 440, marginBottom: 16 }}>
									There aren't any active work orders for this location.
								</div>
							</div>
						}
					/>
				)}
				backText="Back to location"
				openMoreInDefault
				ignoreRefreshCounts
				CustomFooter={ShowAllFooterWorkOrders}
			/>
		</Card>
	);
}

const mapStateToProps = (state) => ({
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(LocationActiveWorkOrders);
